export { default } from './InventoryInfo';

